import React from "react";

import { DivPx } from "@moai/core";
import s from "./pipe.module.scss";
import { Border } from "@tableplus/toolkit";

const Hor = () => (
    <div className={s.hor}>
        <Border color="strong" />
    </div>
);

const Ver: React.FC<{ last: boolean }> = ({ last }) => (
    <div className={last ? s.verLast : s.verMid}>
        <DivPx size={8} />
        <Border color="strong" />
    </div>
);

export const Pipe: React.FC<{ last: boolean }> = ({ last }) => (
    <div className={s.pipe}>
        <Ver last={last} />
        <Hor />
    </div>
);
